import http from './axios'

const queryPage = ({ channelList, platformIdList, gmtCreatedStart, gmtCreatedEnd }) => {
    return http.json_post('/manager/analysis/cityAnalysis', { channelList, platformIdList, gmtCreatedStart, gmtCreatedEnd })
}

const channelList = ({ channel }) => {
    return http.get('/manager/enum/channelList', { channel })
}

export default {
    queryPage,
    channelList
}